import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthApiEndpoints } from '../../../shared/enum/api-endpoints.enum';
import { CollegesResponse, SendOtpRequest, SendOtpResponse, SignupRequest, SignupResponse, VerifyOtpRequest, VerifyOtpResponse, YearsResponse, UserProfileResponse } from '../model/auth.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  sendOtp(payload: SendOtpRequest): Observable<SendOtpResponse> {
    return this.http.post<SendOtpResponse>(`${this.apiUrl}/${AuthApiEndpoints.SEND_OTP}`, payload);
  }

  verifyOtp(payload: VerifyOtpRequest): Observable<VerifyOtpResponse> {
    return this.http.post<VerifyOtpResponse>(`${this.apiUrl}/${AuthApiEndpoints.VERIFY_OTP}`, payload);
  }

  signup(payload: SignupRequest): Observable<SignupResponse> {
    return this.http.post<SignupResponse>(`${this.apiUrl}/${AuthApiEndpoints.SIGNUP}`, payload);
  }

  getColleges(): Observable<CollegesResponse> {
    return this.http.get<CollegesResponse>(`${this.apiUrl}/${AuthApiEndpoints.COLLEGES}`);
  }

  getYears(): Observable<YearsResponse> {
    return this.http.get<YearsResponse>(`${this.apiUrl}/${AuthApiEndpoints.YEARS}`);
  }

  getUserDetails(): Observable<UserProfileResponse> {
    return this.http.get<UserProfileResponse>(`${this.apiUrl}/${AuthApiEndpoints.GET_PROFILE}`);
  }
}
